import { useCallback } from 'react';

type Args<T extends string> = {
  currentValue: T | undefined;
  values: T[];
  onChangeValue: (value: T) => void;
};

export function useValuesNavigation<T extends string>({
  currentValue,
  onChangeValue,
  values,
}: Args<T>) {
  const valueIndex = currentValue ? values.indexOf(currentValue) : -1;
  const previousValue = valueIndex > 0 ? values[valueIndex - 1] : undefined;
  const nextValue =
    valueIndex < values.length - 1 ? values[valueIndex + 1] : undefined;

  const previous = useCallback(() => {
    if (!previousValue) return;

    onChangeValue(previousValue);
  }, [previousValue, onChangeValue]);

  const next = useCallback(() => {
    if (!nextValue) return;

    onChangeValue(nextValue);
  }, [nextValue, onChangeValue]);

  return {
    valueIndex,
    previous,
    hasPrevious: Boolean(previousValue),
    next,
    hasNext: Boolean(nextValue),
  };
}
